const template = document.createElement("template");
template.innerHTML = `
	<h1 id="title">Some Title</h1>
	<v-clock id="asdf"></v-clock>
	<button id="add" type="button">+</button>
	<button id="subtract" type="button">-</button>
`;
const style = document.createElement("style");
style.textContent = `
	
`;
export class ProgressClock extends HTMLElement {
    clock;
    constructor(title, segments, shaded) {
        super();
        title = title !== undefined ? title : this.title;
        segments = segments !== undefined ? segments : this.segments;
        shaded = shaded !== undefined ? shaded : this.shaded;
        const shadow = this.attachShadow({ mode: "open" });
        shadow.appendChild(template.content.cloneNode(true));
        this.clock = shadow.getElementById("asdf");
        this.title = title;
        this.segments = segments;
        this.shaded = shaded;
        const addButton = shadow.getElementById("add");
        addButton.addEventListener("pointerup", this.HandlePlusTick.bind(this), false);
        const subtractButton = shadow.getElementById("subtract");
        subtractButton.addEventListener("pointerup", this.HandleMinusTick.bind(this), false);
        const titleElement = shadow.getElementById("title");
        titleElement.innerText = title;
    }
    static get observedAttributes() {
        return ["segments", "shaded", "title"];
    }
    set segments(value) {
        this.clock.segments = value;
        this.setAttribute("segments", value.toString());
    }
    get segments() {
        const segments = this.getAttribute("segments");
        if (segments === null) {
            throw new Error("Shaded cannot be null");
        }
        const segmentsNum = Number.parseInt(segments, 10);
        if (segmentsNum !== this.clock.segments) {
            throw new Error("State is out-of-sync");
        }
        return segmentsNum;
    }
    set shaded(value) {
        this.clock.shaded = value;
        this.setAttribute("shaded", value.toString());
    }
    get shaded() {
        const shaded = this.getAttribute("shaded");
        if (shaded === null) {
            throw new Error("Shaded cannot be null");
        }
        const shadedNum = Number.parseInt(shaded, 10);
        if (shadedNum !== this.clock.shaded) {
            throw new Error("State is out-of-sync");
        }
        return shadedNum;
    }
    set title(value) {
        this.setAttribute("title", value);
    }
    get title() {
        const title = this.getAttribute("title");
        if (title === null) {
            throw new Error("Title cannot be null");
        }
        return title;
    }
    attributeChangedCallback() {
    }
    connectedCallback() {
    }
    disconnectedCallback() {
        if (this.shadowRoot === null) {
            throw new Error("Shadow Root Cannot be Null");
        }
        const addButton = this.shadowRoot.getElementById("add");
        const subtractButton = this.shadowRoot.getElementById("subtract");
        addButton.removeEventListener("pointerup", this.HandlePlusTick);
        subtractButton.removeEventListener("pointerup", this.HandleMinusTick);
    }
    HandleMinusTick() {
        if (this.shaded === 0) {
            return;
        }
        this.shaded--;
    }
    HandlePlusTick() {
        if (this.shaded >= this.segments) {
            return;
        }
        this.shaded++;
    }
}
customElements.define("v-progress-clock", ProgressClock);
//# sourceMappingURL=progress-clock.js.map